import { IconButton, Slide, Stack, Typography } from '@mui/material';
import { ExitSliderStyle } from './styles';

export const Exitbar = ({
  currentStep,
  flow,
  handleCloseFlowbar,
  showFlowBar,
  isRemoteControlled,
}) => {
  return (
    <Slide
      style={{ top: isRemoteControlled ? 56 : 20 }}
      direction="down"
      in={!!(showFlowBar && currentStep && currentStep?.type === 'regular_step')}
      mountOnEnter
      unmountOnExit
    >
      <Stack sx={ExitSliderStyle} direction="row">
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            width: '24px',
            height: '24px',
            borderRadius: '24px',
            background: '#FFF',
            border: '1px solid #fff',
            '& img': {
              width: 'inherit',
              height: 'inherit',
              borderRadius: '24px',
            },
          }}
        >
          <img
            src={
              flow?.flowSetting?.thumbnail
                ? `${process.env.NEXT_PUBLIC_CDN}/tours/${flow?.tourId}/experience/flows/icons/${flow?.flowSetting?.thumbnail}`
                : '/flow.png'
            }
            alt="flow-thumbnail"
          />
        </Stack>
        <Typography fontSize="16px" lineHeight="'normal'" fontWeight={500}>
          {flow?.name}
        </Typography>
        <IconButton
          sx={{
            width: '69px',
            height: '27px',
            p: '4px 6px 4px 10px',
            gap: 1,
            borderRadius: '130px',
            color: '#fff',
            background: 'rgba(255, 255, 255, 0.10)',
          }}
          onClick={handleCloseFlowbar}
        >
          <Typography fontSize="16px" lineHeight="'normal'" fontWeight={500}>
            Exit
          </Typography>
          <i className="fa fa-times" style={{ color: '#fff', fontSize: '19px' }} />
        </IconButton>
      </Stack>
    </Slide>
  );
};
